import { useContext } from 'react'
import { MeContext, type MeState } from './contexts'

/** Disponibilidad del asesor y su posición en la rotación round-robin. */
export function useMe(): MeState {
  const ctx = useContext(MeContext)
  if (!ctx) throw new Error('useMe must be used within MeProvider')
  return ctx
}
